import { render, staticRenderFns } from "./RenderRole.vue?vue&type=template&id=c377cad2"
import script from "./RenderRole.vue?vue&type=script&lang=ts"
export * from "./RenderRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports